export const DIRECT_ALGOLIA_CONNECTION_UNLEASH_TOGGLE = "direct_algolia_connection"
export const SEARCH_PROXY_V3_CONNECTION_UNLEASH_TOGGLE = "search_proxy_v3_connection"
export const ALGOLIA_MULTI_HOSTS_UNLEASH_TOGGLE = "algolia_multi_hosts"
